// Copyright 2026, Imprivata, Inc.  All rights reserved.

type SortablePositions = { initialIndex: number; index: number };

type DragEndEvent = { canceled: boolean; operation: { source: unknown } };

const sortablePositions = (source: unknown): SortablePositions | null => {
  const sortable = (source as { sortable?: Partial<SortablePositions> } | null | undefined)?.sortable;
  return typeof sortable?.initialIndex === 'number' && typeof sortable.index === 'number'
    ? { initialIndex: sortable.initialIndex, index: sortable.index }
    : null;
};

export const moveFromDragEnd = (event: DragEndEvent, onMove: (from: number, to: number) => void) => {
  if (event.canceled) {
    return;
  }

  const positions = sortablePositions(event.operation.source);
  if (positions === null) {
    return;
  }

  onMove(positions.initialIndex, positions.index);
};
